﻿import { room_passengers_type_combination } from "./room_passengers_type_combination";

export class room_passengers_type {
    public name: string | null = null;
    public room_type_combinations: room_passengers_type_combination[] = [];
}